import {
    removeUserInCourse,
    removeUserInCourseAll,
    editDateExp,
} from '@/service/mylib/list';
// import { loadCategory } from "@/service/category/category";
// import { loadSkill, insertSkill } from "@/service/skill/skill";
import {
    getCourseById,
    // insertCourse,
    // updateCourse
    // updateActive,
    getReportExamScore,
    getReportStudentHistory,
    getReportStudentInCourse,
    getListQuestionExam,
    editScore,
    deleteTicketExam,
} from '@/service/course/course';
import { getExamFaceDetection } from '@/service/course/report';
import {
    // getUserGroup,
    getlistCompany,
    getUserGroupCompany,
    getDetailCompany,
    setUserGroupToCourseByAdmin,
    setDetailCompany,
    setUserGroupToCourse,
} from '@/service/account/manageUserGroup';
import { getRoom } from '@/service/room/room';
import { getUserActiveCalendar, getUserGroup } from '@/service/account/manageUser';
import {
    getOverviewReportCourse,
    getLearnerSuccessCertificate,
    sendCertificateToLearner,
} from '@/service/course/report';
// import sectionRoom from "./room.vue";
import ImportUserDialog from '@/views/course/users.vue';
import AddUserDialog from '@/views/course/accessment/dialog/addUserFromSearch/addUserFromSearch.vue';
import AddUserFromCourseDialog from '@/views/course/accessment/dialog/addUserFromCourse/addUserFromCourse.vue';
import AddUserFromGroupDialog from '@/views/course/accessment/dialog/addUserFromGroup/addUserFromGroup.vue';
import AddUserFromImportDialog from '@/views/course/accessment/dialog/addUserFromImportExcel/addUserFromImportExcel.vue';
import faceDetectionDialog from '@/views/course/accessment/dialog/faceDetection/faceDetection.vue';
//import VueApexCharts from "vue-apexcharts";
// import { cleaningData } from "@/helper/cleaningData";
import firebase from '@/service/firebase';
import DeleteUserFromGroup from '@/views/course/accessment/dialog/deleteUserFromGroup/deleteUserFromGroup.vue';
import store from '../../../store';

import { getTotalRequest } from '@/service/account/login';
var database = firebase.database();

export default {
    components: {
        // sectionRoom,
        ImportUserDialog,
        AddUserDialog,
        AddUserFromCourseDialog,
        AddUserFromGroupDialog,
        AddUserFromImportDialog,
        DeleteUserFromGroup,
        faceDetectionDialog
        //apexchart: VueApexCharts,
    },

    data() {
        return {
            // learningOrder: true,
            // haveDashboard: false,
            // haveInbox: false,
            imageReady: false,
            imgPreview: null,
            userName: '',
            userDialog: false,
            dialogAddLearner: false,
            dialogAddLearnerFromGroup: false,
            dialogAddLearnerFromCourse: false,
            dialogAddLearnerFromImport: false,
            dialogMultiDelete: false,
            dialogMultiDeleteSuccess: false,
            dialogMultiSendCertificate: false,
            loadingSend: false,
            exp_date_dialog: false,
            dialogSuccessEditDateExp: false,
            dialogSendCertificate: false,
            dialogMultiSendCertificateSuccess: false,
            dialogMultiSendCertificateFail: false,
            dialogCalendar: false,
            dialogDeleteUserFromGroup: false,
            dialogFaceDetection: false,

            checkDetection: false,
            date: new Date().toISOString().substr(0, 10),
            nowdate: new Date().toISOString().substr(0, 10),
            menu1: false,
            date_type: 'type_life_time',
            data_type: '',

            loadingDelete: false,
            loader: null,
            valid: true,
            validSearch: true,
            //edit
            isEdit: false,
            courseID: '',
            userGroupSelect: [],
            userGroup: [],
            selectStudents: [],
            selectStudentsCertificate: [],
            reportStudentCertificateList: [],
            arrSendFail: [],

            snackbar: false,
            snackbar2: false,
            error: 'Invalid Data! Please complete all information of the course!',
            success: 'Success, creating course!',
            timeout: 5000,
            detail: {},

            listCompany: [],
            listFilterCompany: [],
            listDetailCompany: [],
            listDetailTemp: [],
            selectedCompany: '',
            userGroupByAdmin: [],
            userGroupSelectByAdmin: [],
            companySelectByAdmin: '',
            indexSelectByAdmin: 0,
            companyModal: false,
            allGroup: [],
            searchCompany: '',
            groupUsers: [],
            arrayGroup: [],


            //search
            searchByUserDialog: false,
            searchByAdminDialog: false,
            userGroupSearch: [],
            userGroupAllAtIndex: [],
            indexSelectIdForSearch: 0,
            groupRules: [
                (v) =>
                    !!v ||
                    this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.userGroupRequired'
                    ),
                // v => (v && v.length >= 2) || "Category must be at least 2 characters"
            ],
            select: false,

            // modal Company
            headers: [
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.organizationLogo'
                    ),
                    align: 'start',
                    sortable: false,
                    value: 'logo',
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.organizationName'
                    ),
                    value: 'title',
                    sortable: false,
                },
                // { text: "Actions", value: "actions", sortable: false }
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.add'
                    ),
                    value: 'actions',
                    sortable: false,
                },
            ],
            searchdata: '',
            pageCount: 1,
            limit: 10,
            params: {},
            selectNewCompany: [],

            // Report
            imageCourse: '',
            title: '',
            courseId: '',
            instructorName: '',
            roomId: '',
            roomsCourse: [],
            section_data: [],
            selectedRoom: '',
            searchdataStudent: '',
            reportStudentList: [],
            status_student_toggle: 0,

            dialogFullReport: true,
            dialogViewReport: false,
            dialogExamReport: false,
            dialogStatus: false,
            dialogStatusActive: false,
            dialogSuccess: false,
            dialogDeleteTicketSuccess: false,
            dialogDelete: false,
            dialogDeleteTicket: false,

            idTicket: '',
            pendingTicket: false,
            image: null,
            searchCourseReport: null,
            searchStudentReport: null,
            studentId: '',
            fullName: '',
            room: '',
            firstName: '',
            lastName: '',
            email: '',
            username: '',
            tel: '',
            birthdate: '',
            gender: '',
            historyList: [],
            historyExamList: [],
            students: [],
            chooseRoom: false,
            objCourse: [],
            knowledge: 0,
            status_toggle: 0,
            countStartedStudents: [],
            countNotStartedStudents: [],
            examTitle: '',
            fullScore: 0,
            numOfQuestions: 0,
            studentReportExams: [],
            dialogEditScoreExam: false,
            arrQuestion: [],
            bool: false,
            faceDetectionDetail: [],

            correct_dialog: false,
            correct_matchsome: [],
            question_type: {
                single: 'ตัวเลือกเดียว',
                fillgaptext: 'เติมคำ',
                matchsome: 'จับคู่',
                multiple: 'หลายตัวเลือก',
                memorygame: 'เกมความจำ',
                crossword: 'เกมไขว้คำ',
                wordsearch: 'เกมหาคำ',
            },

            alert: false,
            chooseSection: false,
            filterdialog: false,
            deleteDialog: false,

            confirmDialog: false,
            registerTutoralert: false,

            loading: true,
            searchby: this.$vuetify.lang.t('$vuetify.courseManagement.courseName'),
            searchType: [
                this.$vuetify.lang.t('$vuetify.courseManagement.courseName'),
                this.$vuetify.lang.t('$vuetify.courseManagement.teacherName'),
            ],
            sortType: [
                this.$vuetify.lang.t(
                    '$vuetify.courseManagement.filterBar.highToLowTime'
                ),
                this.$vuetify.lang.t(
                    '$vuetify.courseManagement.filterBar.lowToHighTime'
                ),
                this.$vuetify.lang.t(
                    '$vuetify.courseManagement.filterBar.highToLowRating'
                ),
                this.$vuetify.lang.t(
                    '$vuetify.courseManagement.filterBar.lowToHighRating'
                ),
            ],

            // series: [
            //   {
            //     name: "ข้อที่ถูก",
            //     data: [44, 55, 57, 56, 61,],
            //   },
            //   {
            //     name: "ข้อที่ถูก",
            //     data: [44, 55, 57, 56, 61,],
            //   },
            //   {
            //     name: "คะแนนของคุณ",
            //     data: [76, 85, 100, 98, 87]
            //   }
            // ],
            // chartOptions: {
            //   chart: {
            //     type: "bar"
            //   },
            //   plotOptions: {
            //     bar: {
            //       horizontal: false,
            //       columnWidth: "50%"
            //     }
            //   },
            //   dataLabels: {
            //     enabled: false
            //   },
            //   stroke: {
            //     show: true,
            //     width: 2,
            //     colors: ["transparent"]
            //   },
            //   grid: {
            //     row: {
            //       colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            //       opacity: 0.5
            //     }
            //   },
            //   xaxis: {
            //     categories: [
            //       "ครั้งที่ 1",
            //       "ครั้งที่ 2",
            //       "ครั้งที่ 3",
            //       "ครั้งที่ 4",
            //       "ครั้งที่ 5"
            //     ]
            //   },
            //   // yaxis: {
            //   //   subtitle: {
            //   //     text: "คะแนน"
            //   //   }
            //   // },
            //   fill: {
            //     opacity: 1
            //   },
            //   tooltip: {
            //     y: {
            //       formatter: function(val) {
            //         return val + " คะแนน";
            //       }
            //     }
            //   }
            // },

            fileExcelName: 'รายงานสรุปผลการสอบ.xls',
            dataForExcel: [],
            // dataForExcel: [
            //   { รายการสอบ: "Another", },
            //   { รายการสอบ: "Another", ครั้งที่1: "Regular cell" },
            //   { รายการสอบ: "Hello", ครั้งที่1: "World", ครั้งที่2: "World" },
            // ],

            // {
            //     text: this.$vuetify.lang.t(
            //       "$vuetify.courseManagement.courseList.studentManagement"
            //     ),
            //     align: "center",
            //     sortable: false,
            //     value: "actions"
            //   },
            //   {
            //     text: this.$vuetify.lang.t(
            //       "$vuetify.courseManagement.courseList.report"
            //     ),
            //     align: "center",
            //     sortable: false,
            //     value: "report"
            //   },


            // headerStudentsCertificate: [
            //   {
            //     text: this.$vuetify.lang.t('$vuetify.fullName'),
            //     value: 'fullName',
            //     align: 'start',
            //     sortable: false,
            //   },
            //   {
            //     text: this.$vuetify.lang.t('$vuetify.email'),
            //     value: 'email',
            //     align: 'center',
            //     sortable: false,
            //   },
            //   {
            //     text: this.$vuetify.lang.t('$vuetify.progress'),
            //     value: 'progress',
            //     align: 'center',
            //     sortable: false,
            //     width: '20%',
            //   },
            //   {
            //     text: '',
            //     value: 'actions',
            //     sortable: false,
            //     align: 'center',
            //     width: '20%',
            //   },
            // ],
            headersMockup: [
                {
                    text: 'วันที่',
                    align: 'center',
                    sortable: false,
                    value: 'date',
                },
                {
                    text: 'เวลาที่ใช้งาน',
                    align: 'center',
                    value: 'timeLearn',
                    sortable: false,
                },
                {
                    text: 'กิจกรรม',
                    align: 'center',
                    value: 'activity',
                    sortable: false,
                },
            ],
            historyItems: [
                {
                    date: '4 เมษายน 2563',
                    timeLearn: '03:00:00 ชม.',
                    activity: 'ดาราศาสตร์',
                },
                {
                    date: '10 เมษายน 2563',
                    timeLearn: '03:00:00',
                    activity: 'วิทยาศาสตร์ ชม.',
                },
            ],
            courses: [],
            sortData: 'เวลา สูง-ต่ำ',
            searchCourse: null,
            searchStudent: null,
            category: [],
            skill: [],
            selectedSkill: [],
            selectedCategory: null,
            active: null,
            deleteItemID: [],
            eventsUser: [],
            focus: "",
            type: "month",
            typeToLabel: {
                month: "Month",
                week: "Week",
                day: "Day",
            },
            selectedEvent: {},
            selectedElement: null,
            selectedOpen: false,
            events: [],
            colors: ["blue", "indigo", "deep-purple", "cyan", "teal", "green", "orange"],
            names: [
                "Meeting",
                "Holiday",
                "PTO",
                "Travel",
                "Event",
                "Birthday",
                "Conference",
                "Party",
            ],

            //user
            manageUserCourseID: '',

            //select dialog
            selectSectionDialog: false,
            section_headers: [
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.dialogChooseStudyingGroup.groupName'
                    ),
                    align: 'start',
                    sortable: false,
                    value: 'title',
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.dialogChooseStudyingGroup.lecturerName'
                    ),
                    value: 'teacher',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.dialogChooseStudyingGroup.numberStudents'
                    ),
                    value: 'countStudent',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.dialogChooseStudyingGroup.chooseGroup'
                    ),
                    sortable: false,
                    align: 'center',
                    value: 'select',
                },
            ],
            // id: room._id,
            //teacher: room.teacher,
            //title: room.title,
            //countStudent: room.countStudent,
            //isPublic: room.isPublic,
            //permissionedit: room.permissionedit
            roomID: '',
            learnerRequest: 0,
            isTeacher: '',
            reject_note: '',
            rooms: [],
            dialogCantPublic: false,
            messageCantPublic: '',

            // paginaton report student
            page_student: 1,
            limit_student: 10,
            pageCount_student: 1,

            page_student_certificate: 1,
            limit_student_certificate: 10,
            pageCount_student_certificate: 1,
            itemStudent: [],
            actionSend: false,

            tempScore: null,

            page_editScore: 1,
            limit_editScore: 50,
            pageCount_editScore: 1,

            // filter student panel
            panel: [0, 1],
            exam_select: ['John'],
            range: [0, 70],
            min: 0,
            max: 100,

            completedUser: 0,
            notCompletedUser: 0,
            totalUser: 0,
            userToday: 0,
            onlineUser: 0,
            onlineUserRef: 0,
            totalPercent: 0,
            sumPercentProgress: 0,
            differencePercent: 0,
            ticketId: null,
            userItem: null,
            // more item
            more_item: [{}],
            // series: [],
            // chartOptions: {
            //   series: this.series,
            //   chart: {
            //     width: 100,
            //     type: "donut",
            //   },
            //   dataLabels: {
            //     enabled: true,
            //   },
            //   title: {
            //     display: true,
            //     text: "Learning Progress",
            //   },
            //   labels: ["Completed", "Not Completed"],
            //   fill: {
            //     type: "gradient",
            //     colors: ["#0779e4", "#699ab2"],
            //   },
            //   colors: ["#0779e4", "#699ab2"],
            //   legend: {
            //     formatter: function (val, opts) {
            //       return (
            //         val +
            //         " " +
            //         opts.w.globals.series[opts.seriesIndex].toFixed(2) +
            //         "%"
            //       );
            //     },
            //     markers: {
            //       fillColors: ["#0779e4", "#699ab2"],
            //     },
            //     offsetY: 0,
            //     height: 50,
            //   },
            //   responsive: [
            //     {
            //       breakpoint: 480,
            //       options: {
            //         chart: {
            //           width: 200,
            //         },
            //         legend: {
            //           position: "bottom",
            //         },
            //       },
            //     },
            //   ],
            // },
            // seriesLearningProgress: [],
            // chartOptionsLearningProgress: {
            //   series: this.seriesLearningProgress,
            //   chart: {
            //     width: 100,
            //     type: "donut",
            //   },
            //   dataLabels: {
            //     enabled: true,
            //   },
            //   title: {
            //     display: true,
            //     text: "About Learners",
            //   },
            //   labels: ["Completed", "Not Completed"],
            //   fill: {
            //     type: "gradient",
            //     colors: ["#0779e4", "#ec0101"],
            //   },
            //   colors: ["#0779e4", "#ec0101"],
            //   legend: {
            //     formatter: function (val, opts) {
            //       return val + " " + opts.w.globals.series[opts.seriesIndex];
            //     },
            //     markers: {
            //       fillColors: ["#0779e4", "#ec0101"],
            //     },
            //     offsetY: 0,
            //     height: 50,
            //   },
            //   responsive: [
            //     {
            //       breakpoint: 480,
            //       options: {
            //         chart: {
            //           width: 200,
            //         },
            //         legend: {
            //           position: "bottom",
            //         },
            //       },
            //     },
            //   ],
            // },
            remove_item: '',
            reject_item: '',
            seriesAngleCircle: [],
            chartOptionsAngleCircle: {
                chart: {
                    height: 400,
                    type: 'radialBar',
                },
                plotOptions: {
                    radialBar: {
                        hollow: {
                            margin: 0,
                            size: '70%',
                            background: '#293450',
                            image: undefined,
                            dropShadow: {
                                enabled: true,
                                top: 3,
                                left: 0,
                                blur: 4,
                                opacity: 0.24,
                            },
                        },
                        track: {
                            background: '#d6e0f0',
                            // dropShadow: {
                            //   enabled: true,
                            //   top: 2,
                            //   left: 0,
                            //   blur: 4,
                            //   opacity: 0.15,
                            // },
                        },
                        dataLabels: {
                            name: {
                                offsetY: -10,
                                color: '#fff',
                                fontSize: '20px',
                            },
                            value: {
                                color: '#fff',
                                fontSize: '30px',
                                show: true,
                            },
                            total: {
                                show: true,
                                color: '#fff',
                                label: 'Completed Learner',
                                formatter: function (w) {
                                    if (w.globals.series[0] > 0) {
                                        return w.globals.series[0] + '%';
                                    } else {
                                        return '00.00%';
                                    }
                                },
                            },
                        },
                    },
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: 'vertical',
                        gradientToColors: ['#87D4F9', '#87D4F9'],
                        stops: [0, 100],
                    },
                },
                stroke: {
                    lineCap: 'round',
                },
                colors: ['#0779e4', '#81b214'],
                labels: ['Completed Learner', 'Learning Progress'],
                legend: {
                    show: false,
                    labels: {
                        useSeriesColors: true,
                    },
                    markers: {
                        size: 0,
                    },
                    formatter: function (seriesName, opts) {
                        return (
                            seriesName + ':  ' + opts.w.globals.series[opts.seriesIndex] + '%'
                        );
                    },
                    itemMargin: {
                        vertical: 3,
                    },
                },
                responsive: [
                    {
                        breakpoint: 480,
                        options: {
                            legend: {
                                show: false,
                            },
                        },
                    },
                ],
            },

            overallSeries: [
                {
                    name: 'Num of Learner',
                    data: [],
                },
            ],
            overallChartOptions: {
                chart: {
                    type: 'area',
                    stacked: false,
                    height: 350,

                    zoom: {
                        type: 'x',
                        enabled: false,
                        autoScaleYaxis: true,
                    },
                    toolbar: {
                        tools: {
                            download: false,
                        },
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                markers: {
                    size: 0,
                },
                title: {
                    text: '',
                    align: 'left',
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shadeIntensity: 1,
                        inverseColors: false,
                        opacityFrom: 0.5,
                        opacityTo: 0.5,
                        stops: [0, 90, 100],
                    },
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            if (Number.isInteger(val)) {
                                return val;
                            }
                        },
                    },
                    title: {
                        text: 'Num of Students',
                    },
                },
                xaxis: {
                    type: 'datetime',
                    tickAmount: 30,
                },
                tooltip: {
                    x: {
                        format: 'dd/MM/yy',
                    },
                    colors: ['#669966'],
                },
            },
        };
    },
    computed: {
        headerStudents() {
            return [
                {
                    text: this.$vuetify.lang.t('$vuetify.pic'),
                    align: 'center',
                    sortable: false,
                    value: 'image',
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.fullName'),
                    value: 'fullName',
                    align: 'start',
                    sortable: false,
                    width: '200',
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.email'),
                    value: 'email',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.group'
                    ),
                    value: 'group',
                    sortable: false,
                    align: 'center',
                },
                // {
                //     text: this.$vuetify.lang.t('$vuetify.username'),
                //     value: 'userName',
                //     align: 'center',
                //     sortable: false,
                // },
                {
                    text: this.$vuetify.lang.t('$vuetify.role'),
                    value: 'role',
                    align: 'center',
                    sortable: false,
                    width: '100',
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.joinedBy'),
                    value: 'joinedBy',
                    align: 'center',
                    sortable: false,
                    width: '150',
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.expiration'),
                    value: 'exp',
                    align: 'center',
                    sortable: false,
                    width: '150',
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.active'),
                    value: 'online',
                    align: 'center',
                    sortable: false,
                    width: '100',
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.progress'),
                    value: 'progress',
                    align: 'center',
                    sortable: false,
                    width: '250',
                },

                // {
                //   text: this.$vuetify.lang.t("$vuetify.room"),
                //   value: "room",
                //   align: "center",
                //   sortable: false
                // },
                // {
                //   text: "",
                //   value: "report",
                //   align: "center",
                //   sortable: false,
                //   width: "5%",
                // },
                {
                    text: '',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                },
                // {
                //   text: this.$vuetify.lang.t("$vuetify.studentInformation"),
                //   value: "actions",
                //   align: "center",
                //   sortable: false
                // }
            ]
        },

        headerStudentsCertificate() {
            return [
                {
                    text: this.$vuetify.lang.t('$vuetify.fullName'),
                    value: 'fullName',
                    align: 'start',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.email'),
                    value: 'email',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t('$vuetify.progress'),
                    value: 'progress',
                    align: 'center',
                    sortable: false,
                    width: '20%',
                },
                {
                    text: '',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: '20%',
                },
            ];
        },

        headerStudentExam() {
            return [
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.reportExam.headerEditScore.no'
                    ),

                    align: 'center',
                    sortable: false,
                    value: 'num',
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.reportExam.headerEditScore.examDate'
                    ),
                    align: 'start',
                    sortable: false,
                    value: 'examDate',
                },
                {
                    text: 'เวลาเริ่ม',
                    value: 'start',
                    align: 'start',
                    sortable: false,
                },

                {
                    text: 'เวลาสิ้นสุด',
                    value: 'end',
                    align: 'start',
                    sortable: false,
                },

                {
                    text: 'เวลาที่ใช้',
                    value: 'timer',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.reportExam.headerEditScore.score'
                    ),
                    align: 'center',
                    sortable: false,
                    value: 'score',
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.reportExam.headerEditScore.correct'
                    ),
                    align: 'center',
                    sortable: false,
                    value: 'correct',
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.reportExam.headerEditScore.wrong'
                    ),
                    align: 'center',
                    sortable: false,
                    value: 'wrong',
                },
                {
                    text: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.manageLearners.reportExam.headerEditScore.noAnswer'
                    ),
                    align: 'center',
                    sortable: false,
                    value: 'noAnswer',
                },
                {
                    text: 'Face detection',
                    align: 'center',
                    sortable: false,
                    value: 'faceDetect',
                },
                {
                    align: 'center',
                    sortable: false,
                    value: 'action',
                },
            ];
        },
    },
    watch: {
        searchdata(keyword) {
            this.searchInfo(keyword);
        },
        searchdataStudent(keyword) {
            this.searchInfoStudent(keyword);
        },
        series(value) {
            console.log('value', value);
        },
        // $vuetify(oldVal,newVal){
        //   oldVal.lang.current
        // }
    },
    methods: {
        async initialize() {
            this.date = new Date().toISOString().substr(0, 10);
            this.nowdate = new Date().toISOString().substr(0, 10);
            // console.log(this.$store.state.permission.superAdmin);
            this.courseID = this.$route.query.id;
            if (this.courseID != null) {
                let params = {
                    id: this.courseID,
                };

                await this.getCourseDetail(params);
                this.isEdit = true;
            }
            await this.getUserGroupList();

            let resultCompany = await getDetailCompany({
                idcourse: this.courseID,
            });

            this.listDetailCompany = resultCompany;
            // if (this.$store.state.permission.superAdmin === false) {
            //   this.listCompany = await getUserGroupCompany();
            // } else {
            //   this.listCompany = await getlistCompany();
            // }
            // this.listFilterCompany = await this.listCompany.data.map(
            //   (company) => company.companies
            // );

            // let tempCompanyId = this.listDetailCompany.map(
            //   (company) => company.companies._id
            // );
            // this.listFilterCompany = this.listFilterCompany.filter(
            //   (isSelectCom) =>
            //     tempCompanyId.findIndex(
            //       (companyId) => companyId === isSelectCom._id
            //     ) === -1
            // );

            // this.listDetailTemp = [];
            // for (let i = 0; i < this.listDetailCompany.length; i++) {
            //   let userGroup = await this.listDetailCompany[i].user_groups.map(
            //     (groups) => groups._id
            //   );
            //   await this.listDetailTemp.push({
            //     user_groups: userGroup,
            //   });
            // }
            // this.userGroupSelectByAdmin = this.listDetailTemp[
            //   this.indexSelectByAdmin
            // ].user_groups;

            // let myCompanyIndex = await this.listDetailCompany.findIndex(
            //   (company) => company.companies._id === this.$store.state.company._id
            // );

            // let indexGroupByOwn = await this.listCompany.data.findIndex(
            //   (company) => company.companies._id === this.$store.state.company._id
            // );
            // this.userGroup =
            //   indexGroupByOwn !== -1
            //     ? await this.listCompany.data[indexGroupByOwn].user_groups
            //     : '';
            // this.userGroup =
            //   indexGroupByOwn !== -1
            //     ? await this.userGroup.filter((group) => group.active !== false)
            //     : [];

            // this.userGroup =
            //   this.userGroup.length > 0 ? await this.addAllGroup(this.userGroup) : [];
            // this.userGroupSelect = this.listDetailTemp[myCompanyIndex]
            //   ? this.listDetailTemp[myCompanyIndex].user_groups
            //   : [];

            // this.userGroupAllAtIndex = [];
            // await this.listCompany.data.forEach(async (company) => {
            //   let arrayGroup = [];
            //   company.user_groups.forEach(async (group) => {
            //     group.child_User_Group.length === 0
            //       ? await arrayGroup.push({
            //           title: group.title,
            //           _id: group._id,
            //         })
            //       : null;
            //     group.child_User_Group.forEach(async (child) => {
            //       child.child_User_Group.length === 0
            //         ? await arrayGroup.push({
            //             title: group.title + ' -> ' + child.title,
            //             _id: child._id,
            //           })
            //         : null;
            //       child.child_User_Group.forEach(async (lastChild) => {
            //         await arrayGroup.push({
            //           title:
            //             group.title + ' -> ' + child.title + ' -> ' + lastChild.title,
            //           _id: lastChild._id,
            //         });
            //       });
            //     });
            //   });
            //   await this.userGroupAllAtIndex.push({
            //     user_groups: arrayGroup,
            //   });
            // });
            // this.indexSelectByAdmin = myCompanyIndex ? myCompanyIndex : 0;
            // this.indexSelectIdForSearch = indexGroupByOwn ? indexGroupByOwn : 0;

            this.openDialogGetReport(this.detail);

            // let requestArr = this.$store.state.requestData;
            // requestArr.forEach((request) => {
            //   if (request._id == this.courseID) {
            //     this.learnerRequest = request.totalLearner
            //   }
            // });
        },
        async CloseDialogDeleteUserFromGroup() {
            this.dialogDeleteUserFromGroup = false;
            this.initialize();

        },
        async openDialogSendCertificate() {
            this.dialogSendCertificate = true;
            console.log(this.reportStudentList);

            await this.getLearnerSuccessCertificateList();

            console.log('idcourse: ', this.detail._id);
            console.log('certificate: ', this.detail.certificate);
            console.log('percentCertificate: ', this.detail.percentCertificate);
            console.log(
                'mailcompany: ',
                this.listDetailCompany[0].companies.contactEmail
            );
        },
        closeDialogDateExp() {
            this.exp_date_dialog = false;
            this.dialogSuccessEditDateExp = false;
            this.date = new Date().toISOString().substr(0, 10);
            this.nowdate = new Date().toISOString().substr(0, 10);
            this.menu1 = false;
            this.date_type = 'type_life_time';
            this.userItem = null;
        },
        async openEditDateExp(item) {
            this.exp_date_dialog = true;
            this.userItem = item;
            if (this.userItem.exp > 0) {
                this.date_type = 'type_spectify_exp';
                this.date = new Date(this.userItem.exp).toISOString().substr(0, 10);
            } else {
                this.date_type = 'type_life_time';
            }
        },
        async saveEditDateExp() {
            // console.log(this.userItem);
            let dt_start = new Date(this.date + ',' + '00' + ':' + '00');
            var startTime = dt_start.setTime(
                dt_start.getTime() - new Date().getTimezoneOffset() * 60 * 1000
            );
            let data = {
                idmylib: this.userItem.idMylib,
                exp: this.date_type == 'type_spectify_exp' ? startTime : 0,
            };
            let result = await editDateExp(data);
            // console.log("result", result);
            if (result) {
                this.dialogSuccessEditDateExp = true;
                this.getStudentCourseList();
            }
        },
        cancelSelect() {
            // this.select();
            this.selectStudents = [];
        },
        confirmMultiDelete() {
            // console.log(this.selectStudents);
            this.dialogMultiDelete = true;
        },
        cancelSelectCertificate() {
            this.selectStudentsCertificate = [];
        },
        confirmSendCertificate() {
            this.dialogMultiSendCertificate = true;
        },
        confirmSendCertificateAction(item) {
            this.dialogMultiSendCertificate = true;
            console.log(item);
            this.itemStudent = item;
            this.actionSend = true;
        },
        async sendSelectCertificate() {
            this.loadingSend = true;
            let arraystudent = [];
            console.log(this.selectStudentsCertificate);
            if (this.actionSend == true) {
                arraystudent.push({
                    idstudent: this.itemStudent.id,
                });
            } else {
                for (let i in this.selectStudentsCertificate) {
                    arraystudent.push({
                        idstudent: this.selectStudentsCertificate[i].id,
                    });
                }
            }
            // console.log(arraystudent);
            // console.log('idcourse: ', this.detail._id);
            // console.log(
            //   'mailcompany: ',
            //   this.listDetailCompany[0].companies.contactEmail
            // );
            let paramsSendCertificate = {
                idcourse: this.detail._id,
                mailcompany: this.listDetailCompany[0].companies.contactEmail,
                arraystudent: arraystudent,
            };
            let resultSendMail = await sendCertificateToLearner(
                paramsSendCertificate
            );
            console.log("result : ", resultSendMail);
            resultSendMail.arraySend.forEach((sending) => {
                if (sending.sendSuccess == false) {
                    this.arrSendFail.push({ id: sending.student });
                } else {
                    this.dialogMultiSendCertificate = false;
                    this.loadingSend = false;
                }

                if (this.arrSendFail.length == 0) {
                    this.dialogMultiSendCertificateSuccess = true;
                    this.loadingSend = false;
                } else {
                    this.dialogMultiSendCertificateFail = true;
                    this.loadingSend = false;
                }
            });
            // if (resultSendMail) {
            //   this.loadingSend = false;
            // }
        },
        closeDialogCertificate() {
            this.dialogSendCertificate = false;
            this.selectStudentsCertificate = [];
        },
        async deleteMultiUser() {
            let arrayidmylib = [];
            for (let i in this.selectStudents) {
                this.loadingDelete = true;
                arrayidmylib.push({
                    id: this.selectStudents[i].idMylib,
                });
            }
            // console.log(arrayidmylib);
            let result = await removeUserInCourseAll({
                arrayidmylib,
            });
            // console.log(result);

            this.loadingDelete = false;
            this.dialogMultiDelete = false;
            this.dialogMultiDeleteSuccess = true;

            this.selectStudents = [];
            this.page_student = 1;
            this.pageCount_student - 1;
            await this.getStudentCourseList();
        },
        removeByUser(item) {
            const index = this.userGroupSelect.indexOf(item._id);
            if (index >= 0) this.userGroupSelect.splice(index, 1);
        },
        removeByAdmin(item) {
            const index = this.userGroupSelectByAdmin.indexOf(item._id);
            if (index >= 0) this.userGroupSelectByAdmin.splice(index, 1);
        },
        async getCourseDetail(params) {
            let detail = await getCourseById(params);
            this.detail = detail;
            // console.log("this.detail", this.detail)
            // this.userGroupSelect = detail.user_groups;
            // this.userGroupSelect = detail.user_groups;
            // this.learningOrder = detail.learningOrder;
            // this.haveDashboard = detail.haveDashboard;
            // this.haveInbox = detail.haveInbox;
        },
        addAllGroup(group) {
            return [
                {
                    levelSub: 1,
                    child_User_Group: group,
                    _id: 'all',
                    title: this.$vuetify.lang.t(
                        '$vuetify.courseManagement.accessStep.all'
                    ),
                },
            ];
        },
        goList() {
            this.$router.push({
                path: '/course',
            });
        },
        goBack() {
            this.$router.go(-1);
        },
        showCheckBox() {
            // console.log(this.selectNewCompany);
        },
        async accessSubmit() {
            // let status = await updateCourse({
            //   ...this.detail,
            //   id: this.detail._id,
            //   learningOrder: this.learningOrder,
            //   haveInbox: this.haveInbox,
            //   haveDashboard: this.haveDashboard
            // });
            //get old user_group
            let groupCompany = [];
            await this.listDetailTemp.forEach((company, index) => {
                index !== this.indexSelectByAdmin
                    ? groupCompany.push(...company.user_groups)
                    : '';
            });
            // user
            if (this.$store.state.permission.superAdmin === false) {
                await setUserGroupToCourse({
                    idcourse: this.courseID,
                    usergroup: this.userGroupSelect,
                });
            }
            // admin
            else if (this.$store.state.permission.superAdmin === true) {
                await setUserGroupToCourseByAdmin({
                    idcourse: this.courseID,
                    usergroup: [...groupCompany, ...this.userGroupSelectByAdmin],
                });
            }

            await this.goList();
            // await this.initialize();
            // console.log(status);
        },
        async selectCompany(id, index) {
            this.select = true;

            let indexSelectId = await this.listCompany.data.findIndex(
                (company) => company.companies._id === id
            );
            this.userGroupByAdmin = this.listCompany.data[indexSelectId].user_groups;

            this.userGroupByAdmin = await this.userGroupByAdmin.filter(
                (group) => group.active !== false
            );

            this.userGroupByAdmin =
                this.userGroupByAdmin.length > 0
                    ? await this.addAllGroup(this.userGroupByAdmin)
                    : [];
            this.indexSelectByAdmin = index;
            this.indexSelectIdForSearch = indexSelectId;
            this.userGroupSelectByAdmin = this.listDetailTemp[index].user_groups;
        },
        openDialog() {
            this.companyModal = true;
        },
        openDialogSearchByUser() {
            this.searchByUserDialog = true;
        },
        openDialogSearchByAdmin() {
            this.searchByAdminDialog = true;
        },
        closesearchByUserDialog() {
            this.userGroupSearch = [];
            this.searchByUserDialog = false;
        },
        closesearchByAdminDialog() {
            this.userGroupSelectByAdmin = [];
            this.searchByAdminDialog = false;
        },
        async closeDialog() {
            this.companyModal = false;
            this.selectNewCompany = [];
        },
        async closeGroupSearchDialog() {
            this.companyModal = false;
            this.selectNewCompany = [];
        },
        refreshStudent() {
            this.initialize();
            this.searchdataStudent = '';
            this.selectedRoom = '';
            this.roomsCourse = [];
            this.section_data = [];
            this.status_student_toggle = 0;
            // this.openDialogGetReport(this.section_data);
        },
        async viewProgressReport(item) {
            this.dialogViewReport = true;
            this.image = item.image;
            this.fullName = item.fullName;
            this.userName = item.userName;
            this.email = item.email;
            this.tel = item.tel == '' || item.tel == null ? '-' : item.tel;
            this.birthdate =
                item.birthdate == '' || item.birthdate == null
                    ? '-'
                    : new Date(item.birthdate).toLocaleDateString();
            this.gender =
                item.gender == '' || item.gender == null ? '-' : item.gender;

            this.courseId = this.$route.query.id;
            this.studentId = item.id;
            this.getReportHistory();
        },
        openRejectDialog(item) {
            this.checkAccept = item.acceptMylib;
            this.remove_item = item.idMylib;
            this.dialogDelete = true;
        },
        async rejectUser() {
            if (this.checkAccept == true) {
                let data = {
                    id: this.remove_item,
                };
                let result = await removeUserInCourse(data);
                if (result) {
                    // let resultTotalRequest = await getTotalRequest();
                    // store.commit("setTotal", resultTotalRequest.course);
                    this.dialogDelete = false;
                    this.checkAccept = null;
                    await this.getStudentCourseList();
                }
            } else {
                // console.log("check Accept is false");
            }
        },
        openConfirmDeleteTicket(item) {
            // console.log(item);
            this.idTicket = item.idTicket;
            this.pendingTicket = item.pending;
            this.dialogDeleteTicket = true;
        },
        async deleteTicket() {
            let data = {
                idticket: this.idTicket,
                pending: this.pendingTicket,
            };
            let result = await deleteTicketExam(data);
            if (result) {
                this.dialogDeleteTicket = false;
                await this.getReportStudentExamScore(this.primaryExamId);
                // console.log("delete ticket exam success");
                this.dialogDeleteTicketSuccess = true;
            }
        },
        async getReportHistory() {
            let result = await getReportStudentHistory({
                idcourse: this.$route.query.id,
                idstudent: this.studentId,
            });
            this.historyList = result;
            this.historyExamList = [];
            this.dataForExcel = [];
            this.knowledge = this.historyList.avgPercentAll;
            this.hisAvg = this.historyExamList.hisAvg;
            // console.log(result);
            result.lectureExam.forEach((history) => {
                this.historyExamList.push({
                    hisExamTitle: history.lecture.exams[0].title,
                    hisExamType: history.type,
                    hisAvg: history.avgScore,
                    hisScore: history.getAllScore.map((term) => term.score),
                    hisWrong: history.getAllScore.map((term) => term.wrong),
                    hisCorrect: history.getAllScore.map((term) => term.correct),
                    series: [
                        {
                            name: 'คะแนนของคุณ',
                            data: history.getAllScore.map((term) => term.score),
                        },
                    ],
                    chartOptions: {
                        // chart: {
                        //   type: "bar"
                        // },
                        // plotOptions: {
                        //   bar: {
                        //     horizontal: false,
                        //     columnWidth: "50%"
                        //   }
                        // },
                        // dataLabels: {
                        //   enabled: false
                        // },
                        // stroke: {
                        //   show: true,
                        //   width: 2,
                        //   colors: ["transparent"]
                        // },
                        // grid: {
                        //   row: {
                        //     colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
                        //     opacity: 0.5
                        //   }
                        // },
                        // xaxis: {
                        //   categories: history.getAllScore.map((term, index) => index + 1)
                        // },
                        // // yaxis: {
                        // //   subtitle: {
                        // //     text: "คะแนน"
                        // //   }
                        // // },
                        // fill: {
                        //   opacity: 1
                        // },
                        // tooltip: {
                        //   y: {
                        //     formatter: function(val) {
                        //       return val + " คะแนน";
                        //     }
                        //   }
                        // }
                        chart: {
                            height: 350,
                            type: 'line',
                            zoom: {
                                enabled: false,
                            },
                        },
                        dataLabels: {
                            enabled: false,
                        },
                        stroke: {
                            curve: 'straight',
                        },
                        grid: {
                            row: {
                                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                                opacity: 0.5,
                            },
                        },
                    },
                });
            });
            this.historyExamList.sort(function (a, b) {
                return b.hisScore.length - a.hisScore.length;
            });
            this.historyExamList.forEach((exam) => {
                let data = {
                    รายการข้อสอบ: exam.hisExamTitle,
                };
                exam.hisScore.forEach((score, index) => {
                    data[`ครั้งที่ ${index + 1}`] = score;
                });
                data[`คะแนนเฉลี่ย`] = exam.hisAvg;

                this.dataForExcel.push(data);
            });
        },

        searchInfo() {
            // this.params.search = this.searchdata;
            // this.getCourseList();
        },
        async insertNewCompany() {
            await setDetailCompany({
                idcourse: this.courseID,
                companies: [
                    ...(await this.listDetailCompany.map(
                        (companies) => companies.companies._id
                    )),
                    ...this.selectNewCompany,
                ],
            });
            await this.closeDialog();
            await this.initialize();
        },
        async deleteCompany(id) {
            let filterOutCompany = await this.listDetailCompany.filter(
                (companies) => companies.companies._id !== id
            );
            let findDeleteIndex = await this.listDetailCompany.findIndex(
                (companies) => companies.companies._id === id
            );
            await setDetailCompany({
                idcourse: this.courseID,
                companies: [
                    ...(await filterOutCompany.map(
                        (companies) => companies.companies._id
                    )),
                ],
            });

            let groupCompany = [];
            await this.listDetailTemp.forEach((company, index) => {
                index !== findDeleteIndex
                    ? groupCompany.push(...company.user_groups)
                    : '';
            });

            await setUserGroupToCourseByAdmin({
                idcourse: this.courseID,
                usergroup: [...groupCompany],
            });

            await this.initialize();
        },
        applyStudentFilter() {
            this.getStudentCourseList();
        },
        async openDialogGetReport(objCourse) {
            let resultRoom = await getRoom({
                idcourse: this.$route.query.id,
            });
            // console.log("resultRoom",resultRoom)
            resultRoom.forEach((room) => {
                this.section_data.push({
                    id: room._id,
                    teacher: room.teacher,
                    title: room.title,
                    countStudent: room.countStudent,
                });
            });

            this.section_data.map((section) => {
                this.roomsCourse.push(section.title);
            });

            this.imageCourse = objCourse.image;
            this.title = objCourse.title;
            this.courseId = this.$route.query.id;
            this.selectedRoom = this.roomsCourse[0];
            // this.roomTitle = item[0].title;
            this.instructorName = objCourse.owner_by_students[0]._id.displayName;
            this.roomId = this.section_data[0].id;
            // this.getOverviewReport();
            this.getStudentCourseList();
            await this.setTotalRequest()
            let requestArr = this.$store.state.requestData;
            requestArr.forEach((request) => {
                if (request._id == this.courseID) {
                    request.room.forEach((room) => {
                        if (room._id == this.section_data[0].id) {
                            this.learnerRequest = request.totalLearner;
                        }
                    });
                }
            });

            this.onlineUserRef = database
                .ref('/onlineUser')
                .child(`/course_${this.$route.query.id}`);
            this.onlineUserRef.on('value', (snapshot) => {
                this.onlineUser = snapshot.val()
                    ? snapshot.val().length > 1
                        ? snapshot.val().length
                        : 1
                    : 0;
            });
        },
        async changePageStudent(page) {
            this.page_student = page;
            await this.getStudentCourseList();
        },
        async changePageStudentCertificate(page) {
            this.page_student_certificate = page;
            await this.getStudentCourseList();
        },
        async changePageEditScore() {
            this.arrTempScore = [];
            this.arrQuestion.forEach((arrq) => {
                this.arrTempScore.push({
                    score: arrq.studentScore,
                });
            });
            await this.getQuestionListExam();
        },
        closeDialogFullReport() {
            this.dialogFullReport = false;

            // Clear Dialog Full Report Data
            this.imageCourse = '';
            this.title = '';
            this.courseId = '';
            this.instructorName = '';
            this.roomId = '';
            this.roomsCourse = [];
            this.section_data = [];
            this.selectedRoom = '';
            this.searchdataStudent = '';
            this.reportStudentList = [];
            this.status_student_toggle = 0;
        },
        closeDialogViewReport() {
            // Clear Dialog View Report Data
            this.dialogViewReport = false;

            this.fullName = '';
            this.userName = '';
            this.email = '';
            this.tel = '';
            this.birthdate = '';
            this.gender = '';

            this.historyList = [];
        },
        closeDialogExamReport() {
            this.dialogExamReport = false;
            this.examTitle = '';
            this.fullScore = '';
            this.numOfQuestions = '';
            this.studentReportExams = [];
        },
        async CloseUserModal() {
            this.userDialog = false;
            this.learnerRequest = 0;
            await this.setTotalRequest()
            let requestArr = this.$store.state.requestData;
            let index = this.roomsCourse.indexOf(this.selectedRoom);
            requestArr.forEach((request) => {
                if (request._id == this.courseID) {
                    request.room.forEach((room) => {
                        if (room._id == this.section_data[index].id) {
                            this.learnerRequest = request.totalLearner;
                        }
                    });
                }
            });
            await this.getStudentCourseList();
        },
        async CloseUserModalAddLearner() {
            this.dialogAddLearner = false;

            this.learnerRequest = 0;
            await this.setTotalRequest()
            let requestArr = this.$store.state.requestData;
            let index = this.roomsCourse.indexOf(this.selectedRoom);
            requestArr.forEach((request) => {
                if (request._id == this.courseID) {
                    request.room.forEach((room) => {
                        if (room._id == this.section_data[index].id) {
                            this.learnerRequest = request.totalLearner;
                        }
                    });
                }
            });
            await this.getStudentCourseList();
        },
        async CloseUserModalAddLearnerFromGroup() {
            this.dialogAddLearnerFromGroup = false;
            this.learnerRequest = 0;
            await this.setTotalRequest()
            let requestArr = this.$store.state.requestData;
            let index = this.roomsCourse.indexOf(this.selectedRoom);
            requestArr.forEach((request) => {
                if (request._id == this.courseID) {
                    request.room.forEach((room) => {
                        if (room._id == this.section_data[index].id) {
                            this.learnerRequest = request.totalLearner;
                        }
                    });
                }
            });
            await this.getStudentCourseList();
        },
        async CloseUserModalAddLearnerFromCourse() {
            this.dialogAddLearnerFromCourse = false;
            this.learnerRequest = 0;
            await this.setTotalRequest()
            let requestArr = this.$store.state.requestData;
            let index = this.roomsCourse.indexOf(this.selectedRoom);
            requestArr.forEach((request) => {
                if (request._id == this.courseID) {
                    request.room.forEach((room) => {
                        if (room._id == this.section_data[index].id) {
                            this.learnerRequest = request.totalLearner;
                        }
                    });
                }
            });
            await this.getStudentCourseList();
        },
        async CloseUserModalAddLearnerFromImport() {
            this.dialogAddLearnerFromImport = false;
            this.learnerRequest = 0;
            await this.setTotalRequest()
            let requestArr = this.$store.state.requestData;
            let index = this.roomsCourse.indexOf(this.selectedRoom);
            requestArr.forEach((request) => {
                if (request._id == this.courseID) {
                    request.room.forEach((room) => {
                        if (room._id == this.section_data[index].id) {
                            this.learnerRequest = request.totalLearner;
                        }
                    });
                }
            });
            await this.getStudentCourseList();
        },

        closeDialogReject() {
            this.dialogDelete = false;
            this.checkAccept = null;
            this.remove_item = '';
        },
        closeDialogDeleteTicket() {
            this.dialogDeleteTicket = false;
            this.idTicket = '';
        },
        async closedialogEditScoreExam() {
            this.dialogEditScoreExam = false;
            this.arrQuestion = [];
            this.bool = false;
            await this.getReportStudentExamScore(this.primaryExamId);
        },
        searchInfoStudent(keyword) {
            this.params.search = keyword;
            this.getStudentCourseList();
        },
        async onChangeRoom() {
            let index = this.roomsCourse.indexOf(this.selectedRoom);
            // this.roomTitle = this.section_data[index].title;
            this.instructorName = this.section_data[index].teacher.displayName;
            this.roomId = this.section_data[index].id;
            this.courseId = this.$route.query.id;
            // console.log("Selected Room:", this.section_data[index]);
            // await this.getOverviewReport();
            await this.getStudentCourseList();

            this.learnerRequest = 0;
            await this.setTotalRequest()
            let requestArr = this.$store.state.requestData;
            requestArr.forEach((request) => {
                if (request._id == this.courseID) {
                    request.room.forEach((room) => {
                        if (room._id == this.section_data[index].id) {
                            this.learnerRequest = request.totalLearner;
                        }
                    });
                }
            });
        },
        // async getOverviewReport() {
        //   let result = await getOverviewReportCourse({
        //     idcourse: this.$route.query.id,
        //     idroom: this.roomId,
        //   });
        //   this.completedUser = result.countPercent100;
        //   this.notCompletedUser = result.allUser - result.countPercent100;
        //   this.totalUser = result.allUser;
        //   this.userToday = result.onlineToday.countOnline;
        //   this.totalPercent = result.allUser * 100;
        //   this.sumPercentProgress = result.sumPercent;
        //   this.sumPercentProgress = (result.sumPercent * 100) / this.totalPercent;
        //   this.differencePercent = 100 - this.sumPercentProgress;
        //   this.series = [this.sumPercentProgress, this.differencePercent];
        //   this.seriesLearningProgress = [this.completedUser, this.notCompletedUser];
        //   this.seriesAngleCircle = [
        //     ((this.completedUser * 100) / this.totalUser).toFixed(2),
        //     this.sumPercentProgress.toFixed(2),
        //   ];
        //   let arrayGraph = result.arrayGraph;
        //   this.overallSeries[0].data = [];
        //   arrayGraph.map((graph) => {
        //     this.overallSeries[0].data.push([graph.date, graph.countOnline]);
        //   });
        //   let newSeries = this.overallSeries[0].data;
        //   this.overallSeries = [
        //     {
        //       data: newSeries,
        //     },
        //   ];
        // },
        async getLearnerSuccessCertificateList() {
            let paramsCertificate = {
                idcourse: this.$route.query.id,
                idroom: this.roomId,
                // search: this.params.search,
                // page: this.page_student_certificate,
                // limit: this.limit_student_certificate,
            };
            let resultStudent = await getLearnerSuccessCertificate(paramsCertificate);
            // console.log('certificate : ', resultStudent);

            resultStudent = resultStudent.filter(
                (filter) => filter.history.percent >= this.detail.percentCertificate
            );

            this.reportStudentCertificateList = [];
            resultStudent.forEach((student) => {
                this.reportStudentCertificateList.push({
                    id: student.student,
                    fullName: student.firstName + ' ' + student.lastName,
                    email: student.email,
                    percent: student.history.percent,
                    sendStatus: null,
                });
            });
            this.imageReady = true;
            this.loading = false;
            console.log(this.reportStudentCertificateList);
        },

        async getStudentCourseList() {
            this.loading = true;

            let resultStudent = await getReportStudentInCourse({
                idcourse: this.$route.query.id,
                idroom: this.roomId,
                search: this.params.search,
                page: this.page_student,
                limit: this.limit_student,
            });

            let result = [];
            this.countStartedStudents = resultStudent.data.filter(
                (filter) => filter.percent > 0
            );
            this.countNotStartedStudents = resultStudent.data.filter(
                (filter) => filter.percent == 0
            );

            if (this.status_student_toggle == 1) {
                result = resultStudent.data.filter((filter) => filter.percent > 0);
            } else if (this.status_student_toggle == 2) {
                result = resultStudent.data.filter((filter) => filter.percent == 0);
            } else {
                result = resultStudent.data;
            }

            this.reportStudentList = [];
            result.forEach(async (student) => {
                this.reportStudentList.push({
                    id: student._id,
                    image: student.image,
                    fullName: student.firstName + ' ' + student.lastName,
                    email: student.email,
                    userName: student.username,
                    tel: student.tel,
                    birthdate: student.birthdate,
                    gender: student.gender,
                    room: student.room.title,
                    percent: student.percent,
                    acceptMylib: student.acceptMylib,
                    idMylib: student.idMylib,
                    exp: student.exp,
                    note: student.note,
                    lastdayTimestamp: parseInt(student.lastdayTimestamp),
                    activeDay: await this.getDifferentDay(
                        parseInt(student.lastdayTimestamp)
                    ),
                    role: await this.getRole(student.role),
                    group: await this.showGroupList(student.user_groups),
                });
            });
            this.imageReady = true;
            this.loading = false;
            this.pageCount_student = resultStudent.maxPage;
            console.log(this.reportStudentList);
        },
        async showGroupList(userGroup) {
            let userGroupOutput = [];
            await userGroup.forEach(
                async (grouplist) =>
                    await this.arrayGroup.forEach(async (group) =>
                        group._id == grouplist._id
                            ? await userGroupOutput.push(group)
                            : null
                    )
            );
            return userGroupOutput;
        },
        async getUserGroupList() {
            let result = await getUserGroup({
                idcourse: this.courseId,
            });
            console.log(result)
            this.groupUsers = [];
            // let userGroupAllAtIndex=[]
            this.arrayGroup = [];
            await result.forEach(async (group) => {
                // let arrayGroup = []
                group.child_User_Group.length === 0
                    ? await this.groupUsers.push({
                        title: group.title,
                        _id: group._id,
                    })
                    : null;
                group.child_User_Group.forEach(async (child) => {
                    child.child_User_Group.length === 0
                        ? await this.groupUsers.push({
                            title: group.title + ' -> ' + child.title,
                            _id: child._id,
                        })
                        : null;
                    child.child_User_Group.forEach(async (lastChild) => {
                        await this.groupUsers.push({
                            title:
                                group.title + ' -> ' + child.title + ' -> ' + lastChild.title,
                            _id: lastChild._id,
                        });
                    });
                });
                // await userGroupAllAtIndex.push({arrayGroup})
            });
            this.arrayGroup = this.groupUsers;
            // this.groupUsers = result;
            // this.filterGroupResult = result;
        },
        getRole(role) {
            // defind permission by Role
            if (role.isAdmin == true) {
                return 'Administrator'
            } else if (role.isCreator == true) {
                return 'Creator'
            } else if (role.isOwner == true) {
                return 'Owner'
            } else if (role.isStudent == true) {
                return 'Student'
            }
        },
        viewDay({ date }) {
            this.focus = date;
            this.type = "day";
        },
        getEventColor(event) {
            return event.color;
        },
        setToday() {
            this.focus = "";
        },
        async prev() {
            await this.$refs.calendar.prev();
            let paramsCalendar = {
                idstudent: this.student.id,
                month: this.$refs.calendar.lastStart.month,
                year: this.$refs.calendar.lastStart.year,
            };
            let result = await getUserActiveCalendar(paramsCalendar);

            this.eventsUser = [];
            let arrEvent = [];
            result.forEach((event) => {
                if (event.arrayCourseDay.length) {
                    event.arrayCourseDay.forEach((eventCourse, index) => {
                        let time = eventCourse.endTime - eventCourse.startTime;
                        let second = time / 1000;
                        // console.log(second);
                        arrEvent.push({
                            // timed: second >= 120 ? true : false,
                            timed: true,
                            color: this.colors[index] ? this.colors[index] : 'grey darken-1',
                            name: eventCourse.title,
                            start: new Date(eventCourse.startTime),
                            end: new Date(eventCourse.endTime),
                        });
                    });
                }
            });
            this.eventsUser = arrEvent;
        },
        async next() {
            await this.$refs.calendar.next();
            let paramsCalendar = {
                idstudent: this.student.id,
                month: this.$refs.calendar.lastStart.month,
                year: this.$refs.calendar.lastStart.year,
            };
            let result = await getUserActiveCalendar(paramsCalendar);
            this.eventsUser = [];
            let arrEvent = [];
            result.forEach((event) => {
                if (event.arrayCourseDay.length) {
                    event.arrayCourseDay.forEach((eventCourse, index) => {
                        let time = eventCourse.endTime - eventCourse.startTime;
                        let second = time / 1000;
                        // console.log(second);
                        arrEvent.push({
                            // timed: second >= 120 ? true : false,
                            timed: true,
                            color: this.colors[index] ? this.colors[index] : 'grey darken-1',
                            name: eventCourse.title,
                            start: new Date(eventCourse.startTime),
                            end: new Date(eventCourse.endTime),
                        });
                    });
                }
            });
            this.eventsUser = arrEvent;
        },
        showEvent({ nativeEvent, event }) {
            const open = () => {
                this.selectedEvent = event;
                this.selectedElement = nativeEvent.target;
                setTimeout(() => {
                    this.selectedOpen = true;
                }, 10);
            };

            if (this.selectedOpen) {
                this.selectedOpen = false;
                setTimeout(open, 10);
            } else {
                open();
            }

            nativeEvent.stopPropagation();
        },
        updateRange({ start, end }) {
            const events = [];

            const min = new Date(`${start.date}T00:00:00`);
            const max = new Date(`${end.date}T23:59:59`);
            const days = (max.getTime() - min.getTime()) / 86400000;
            const eventCount = this.rnd(days, days + 20);

            for (let i = 0; i < eventCount; i++) {
                const allDay = this.rnd(0, 3) === 0;
                const firstTimestamp = this.rnd(min.getTime(), max.getTime());
                const first = new Date(firstTimestamp - (firstTimestamp % 900000));
                const secondTimestamp = this.rnd(2, allDay ? 288 : 8) * 900000;
                const second = new Date(first.getTime() + secondTimestamp);

                events.push({
                    name: this.names[this.rnd(0, this.names.length - 1)],
                    start: first,
                    end: second,
                    color: this.colors[this.rnd(0, this.colors.length - 1)],
                    timed: !allDay,
                });
            }

            this.events = events;
        },
        rnd(a, b) {
            return Math.floor((b - a + 1) * Math.random()) + a;
        },
        async openCalendar(item) {
            this.dialogCalendar = true;

            this.student = item;
            await this.getUserActiveCalendar();
            console.log(this.$refs.calendar);
        },
        closeCalendar() {
            this.dialogCalendar = false;
            this.type = 'month';
            this.type_toggle = 3;
            this.setToday();
        },
        setTypeCalendar() {
            switch (this.type_toggle) {
                case 0:
                    this.setToday();
                    break;
                case 1:
                    this.type = 'day';
                    break;
                case 2:
                    this.type = 'week';
                    break;
                case 3:
                    this.type = 'month';
                    break;
            }
        },
        async getUserActiveCalendar() {
            let date = new Date();
            let month = date.getMonth();
            let year = date.getFullYear();
            console.log(date, ' // ', month, ' // ', year);
            let paramsCalendar = {
                idstudent: this.student.id,
                month: month + 1,
                year: year,
            };
            let result = await getUserActiveCalendar(paramsCalendar);
            console.log(result);
            let arrEvent = [];
            this.eventsUser = [];
            result.forEach((event) => {
                if (event.arrayCourseDay.length) {
                    event.arrayCourseDay.forEach((eventCourse, index) => {
                        let time = eventCourse.endTime - eventCourse.startTime;
                        let second = time / 1000;
                        // console.log(second);
                        arrEvent.push({
                            // timed: second >= 120 ? true : false,
                            timed: true,
                            color: this.colors[index] ? this.colors[index] : 'grey darken-1',
                            name: eventCourse.title,
                            start: new Date(eventCourse.startTime),
                            end: new Date(eventCourse.endTime),
                        });
                    });
                }
            });
            console.log(arrEvent);
            this.eventsUser = arrEvent;
        },
        async getDifferentDay(timeStamp) {
            let nowDate = new Date().toISOString();
            let day_now = new Date(nowDate).getTime();
            // console.log(day_now, timeStamp, day_now - timeStamp);
            let day_active = timeStamp;
            let arrActive = [];

            var diffInMs = day_now - day_active;

            var diffInDays = diffInMs / (1000 * 60 * 60 * 24);
            var diffInDay = diffInMs % (1000 * 60 * 60 * 24);

            var diffInHrs = diffInDay / (1000 * 60 * 60);
            var diffInHr = diffInDay % (1000 * 60 * 60);

            var diffInMins = diffInHr / (1000 * 60);
            var diffInMin = diffInHr % (1000 * 60);

            var diffInSecs = diffInMin / 1000;

            if (timeStamp == -1) {
                arrActive.push({
                    diffInDays: 0,
                    diffInHrs: 0,
                    diffInMins: 0,
                    diffInSecs: 0,
                });
            } else if (timeStamp) {
                arrActive.push({
                    diffInDays: diffInDays.toFixed(),
                    diffInHrs: diffInHrs.toFixed(),
                    diffInMins: diffInMins.toFixed(),
                    diffInSecs: diffInSecs.toFixed(),
                });
            } else {
                arrActive.push({
                    diffInDays: -9999,
                    diffInHrs: -9999,
                    diffInMins: -9999,
                    diffInSecs: -9999,
                });
            }

            return arrActive;
        },
        async getReportStudentExamScore(examId) {
            this.studentReportExams = [];
            this.primaryExamId = examId;
            let result = await getReportExamScore({
                idexam: examId,
                idstudent: this.studentId,
            });

            this.fullScore = result.maxScore;
            this.numOfQuestions = result.countQuestion;
            let numExam = result.data.length + 1;
            console.log(result);
            if (result.pendingTicket) {
                for (let ticket of result.pendingTicket) {
                    this.studentReportExams.push({
                        idTicket: ticket._id,
                        examId: this.primaryExamId,
                        studentId: this.studentId,
                        num: numExam,
                        examDate:
                            new Date(ticket.created_at).toDateString() +
                            ' ' +
                            new Date(ticket.created_at).toLocaleTimeString(),
                        start:
                            new Date(ticket.created_at).toDateString() +
                            ' ' +
                            new Date(ticket.created_at).toLocaleTimeString(),
                        end:
                            new Date(ticket.created_at + ticket.timer).toDateString() +
                            ' ' +
                            new Date(ticket.created_at + ticket.timer).toLocaleTimeString(),
                        timer: ticket.timer > 0 ? this.getTimer(ticket.timer) : 0,
                        score: ticket.score,
                        correct: ticket.correct,
                        wrong: ticket.wrong,
                        noAnswer: ticket.noAnswer,
                        pending: true,
                        statusFace: ticket.statusFace,
                        photoFace: ticket.photoFace,
                    });
                }
            }
            result.data.forEach((reportExam) => {
                numExam--;
                this.studentReportExams.push({
                    idTicket: reportExam._id,
                    examId: this.primaryExamId,
                    studentId: this.studentId,
                    num: numExam,
                    examDate:
                        new Date(reportExam.created_at).toDateString() +
                        ' ' +
                        new Date(reportExam.created_at).toLocaleTimeString(),
                    start:
                        new Date(reportExam.created_at).toDateString() +
                        ' ' +
                        new Date(reportExam.created_at).toLocaleTimeString(),
                    end:
                        new Date(reportExam.created_at + reportExam.timer).toDateString() +
                        ' ' +
                        new Date(
                            reportExam.created_at + reportExam.timer
                        ).toLocaleTimeString(),
                    timer: reportExam.timer > 0 ? this.getTimer(reportExam.timer) : 0,
                    score: reportExam.score,
                    correct: reportExam.correct,
                    wrong: reportExam.wrong,
                    noAnswer: reportExam.noAnswer,
                    pending: false,
                    statusFace: reportExam.statusFace,
                    photoFace: reportExam.photoFace,
                });
            });
            console.log(this.studentReportExams)
        },
        getTimer(timer) {
            var sec_num = parseInt(timer / 1000); // don't forget the second param
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - hours * 3600) / 60);
            var seconds = sec_num - hours * 3600 - minutes * 60;

            if (hours < 10) {
                hours = '0' + hours;
            }
            if (minutes < 10) {
                minutes = '0' + minutes;
            }
            if (seconds < 10) {
                seconds = '0' + seconds;
            }
            return hours + ':' + minutes + ':' + seconds;
        },
        async getQuestionListExam() {
            let data = {
                idexam: this.itemExam.examId,
                idstudent: this.itemExam.studentId,
                term: this.itemExam.num - 1,
                page: this.page_editScore,
                limit: 10,
            };
            let result = await getListQuestionExam(data);

            this.arrQuestion = [];
            result.data.forEach((quiz) => {
                // if (quiz.question.typeQuestion != "article") {
                this.arrQuestion.push({
                    id: quiz.question._id,
                    question: quiz.question.question,
                    questionType: quiz.question.typeQuestion,
                    choices: quiz.question.choices,
                    correctAnswer: quiz.question.correct,
                    correctText: quiz.question.correctText,
                    questionMatch: quiz.question.questionMatch,
                    correctMatch: quiz.question.correctMatch,
                    correctPuzzleGrid: quiz.question.correctPuzzleGrid,
                    // imageQuestion: quiz.question.imageQuestion,
                    QuestionScore: quiz.question.score,

                    studentAnswerText: quiz.answerStudent
                        ? quiz.answerStudent.answerText
                        : null,
                    studentAnswerMatch: quiz.answerStudent
                        ? quiz.answerStudent.answerMatch
                        : null,
                    studentAnswerMemoryGame: quiz.answerStudent
                        ? quiz.answerStudent.answerMemoryGame
                        : null,
                    studentAnswerPuzzleGrid: quiz.answerStudent
                        ? quiz.answerStudent.answerPuzzleGrid
                        : null,
                    studentAnswer:
                        quiz.answerStudent && quiz.answerStudent.answer !== null
                            ? quiz.answerStudent.answer
                            : null,
                    studentIdState: quiz.answerStudent ? quiz.answerStudent._id : null,
                    studentScore: quiz.answerStudent ? quiz.answerStudent.score : 0,
                    divider: true,
                    boolean: false,
                });
                // }

            });
            this.pageCount_editScore = result.maxPage;

        },
        //check student anser correct
        getstudentCorrectAnser(idStudentAnsser, idCorrectAnser) {
            let id_correct = '';
            idStudentAnsser == idCorrectAnser
                ? (id_correct = idStudentAnsser)
                : (id_correct = '');
            return id_correct;
        },
        getCorrectAnser(idAnswer, correctAnser) {
            if (correctAnser.length) {
                correctAnser.forEach(correct => {
                    if (correct._id == idAnswer) {

                        return correct._id
                    }
                });
                // let correct = correctAnser.filter((key) => key._id == idAnswer);
                // return correct;
            } else {
                let correct = correctAnser.filter((key) => key == idAnswer);
                return correct;
            }

        },
        chekCorrectAnswer(idChioce, correctAnswer) {

            let check = false
            for (let index = 0; index < correctAnswer.correctAnswer.length; index++) {
                const correct = correctAnswer.correctAnswer[index];
                if (correct._id == idChioce) {
                    check = true
                    break

                }
            }

            return check

        },


        showAnswer(corrects, choices) {
            let correct_match = [];
            choices.filter(function (choice) {
                corrects.correct.forEach(correct => {
                    if (correct._id == choice._id) {
                        correct_match.push(choice);

                    }
                });

            });
            // this.correct_matchsome = answer[0];
            this.correct_matchsome = correct_match;
            // console.log("showAnswer -> this.correct_matchsome", this.correct_matchsome)
            this.correct_dialog = true;
        },
        editScore(item) {

            this.itemExam = item;
            console.log("editScore -> this.itemExam", this.itemExam)
            this.getQuestionListExam();
            this.dialogEditScoreExam = true;
        },
        async openDialogFaceDetection(item) {
            console.log(item)
            this.ticketId = item.idTicket;

            this.dialogFaceDetection = true;

        },
        async CloseFaceDetectionDialog() {
            this.dialogFaceDetection = false;
            await this.getReportStudentExamScore(this.primaryExamId);

        },
        editScoreExam(item) {
            this.bool = true;
            item.boolean = true;
            this.tempScore = item.studentScore;
            this.editScoreItem = item;
        },
        cancelEditScore(item) {
            item.boolean = false;
            item.studentScore = this.tempScore;
            this.bool = false;
        },

        async saveEditScore(item) {
            item.boolean = false;
            this.bool = false;

            this.editScoreItem = item;
            console.log("saveEditScore -> this.editScoreItem", this.editScoreItem)
            if (
                this.editScoreItem.studentScore == '' ||
                this.editScoreItem.studentScore == null
            ) {
                this.editScoreItem.studentScore = 0;
            }
            let data = {
                idstate: this.editScoreItem.studentIdState,
                score: this.editScoreItem.studentScore,
            };
            // for (var i = 0; i < this.pageCount_editScore; i++) {
            // for (var q = 0; q < this.arrQuestion.length; q++) {
            //   let result = await editScore({
            //     idstate: this.arrQuestion[q].studentIdState,
            //     score: this.arrQuestion[q].studentScore,
            //   });
            // console.log("post api page of : ", i, " && rpm : ", q);
            // console.log(result);
            // }
            // }
            let result = await editScore(data);
            if (result) {
                this.getQuestionListExam();
            }
            this.dialogSuccess = true;
            // this.closedialogEditScoreExam();
        },
        async setTotalRequest(){
            let resultTotalRequest = await getTotalRequest();
            await store.commit('setTotal', resultTotalRequest.course);
        }
    },
    // beforeMount(){
    //   this.initialize();
    // }
    // async mounted() {
    //   await this.initialize();
    // },
    async beforeMount() {
        await this.initialize();
    },
};